(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const header = document.querySelector('[data-header]');
  if (header) {
    const toggle = header.querySelector('[data-menu-toggle]');
    const drawer = header.querySelector('#header-drawer');

    const setOpen = (open) => {
      toggle.setAttribute('aria-expanded', String(open));
      drawer.hidden = !open;
    };

    toggle?.addEventListener('click', () => {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });

    /* Escape closes it, as every disclosure should, and focus goes back to the control
       that opened it rather than to the top of the document. */
    header.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (toggle.getAttribute('aria-expanded') !== 'true') return;
      setOpen(false);
      toggle.focus();
    });

    /* Widening past the breakpoint leaves the drawer open under a header that already
       shows the same links inline — a duplicate row, and aria-expanded lying about it. */
    const wide = window.matchMedia('(min-width: 46.875rem)');
    const sync = () => { if (wide.matches) setOpen(false); };
    wide.addEventListener('change', sync);
    sync();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // Gallery: every frame is rendered; the thumbnails toggle which one is shown, so the
  // page still shows a photograph with JavaScript switched off.
  document.querySelectorAll('[data-product-root]').forEach((root) => {
    // Two controls drive one gallery — thumbnails above the hinge, dots below — and both
    // carry data-media-thumb. State syncs by media id, not by element identity: keyed on
    // identity, tapping a dot cleared the matching thumbnail, so the two disagreed the
    // moment the container crossed the hinge and the other one became visible.
    const controls = Array.from(root.querySelectorAll('[data-media-thumb]'));
    const frames = Array.from(root.querySelectorAll('[data-media-frame]'));
    const ids = frames.map((f) => f.getAttribute('data-media-frame'));
    if (!ids.length) return;
    let index = 0;

    // Index over FRAMES, not controls: there are two controls per photograph, so counting
    // controls would advance a swipe through half the gallery twice.
    function show(next) {
      index = (next + ids.length) % ids.length;
      const id = ids[index];
      frames.forEach((frame) => {
        frame.classList.toggle('product__frame--hidden', frame.getAttribute('data-media-frame') !== id);
      });
      controls.forEach((control) => {
        const current = control.getAttribute('data-media-thumb') === id;
        control.classList.toggle('product__thumb--active', current);
        if (current) {
          control.setAttribute('aria-current', 'true');
        } else {
          control.removeAttribute('aria-current');
        }
      });
    }

    controls.forEach((control) => {
      control.addEventListener('click', () => show(ids.indexOf(control.getAttribute('data-media-thumb'))));
    });

    // The photograph is the swipe surface. Single-image products get no handler at all,
    // so the arch keeps its ordinary focus behaviour and nothing advertises navigation
    // that would go nowhere.
    const stage = root.querySelector('.product__stage');
    if (stage && ids.length > 1 && window.galleryNav) {
      window.galleryNav(stage, {
        label: root.querySelector('.product__name') ? root.querySelector('.product__name').textContent.trim() + ' photographs' : 'Photographs',
        prev: () => show(index - 1),
        next: () => show(index + 1)
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
